import Dcode from "../assets/portfolio/dcode.png"
import Telinsta from "../assets/portfolio/telinsta.png"
import Bigmart from "../assets/portfolio/bigmart.png"
import Weather from "../assets/portfolio/weather.png"
import Tictactoe from "../assets/portfolio/tictactoe.png"
import MovieHive from "../assets/portfolio/moviehive.png"
import StockSnap from "../assets/portfolio/stocksnap.png"

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    img: Telinsta,
    title: "Telinsta",
    desc: "Social Media app (user interface inspired from instagram) for posting images, chatting which has authentication contains OTP verification.",
    demo: "https://telinsta.onrender.com",
    source: "https://github.com/PrashantS360/Telinsta",
  },
  {
    img: Bigmart,
    title: "BigMart",
    desc: "An e-commerce store (flipkart clone) where users can add items to the cart and order them at exciting prices with great discounts.",
    demo: "https://bigmart-shoplify.netlify.app/",
    source: "https://github.com/PrashantS360/BigMart",
  },
  {
    img: StockSnap,
    title: "StockSnap",
    desc: "We cover a wide range of stocks, including large-cap, mid-cap, and small-cap companies across various sectors.",
    demo: "https://stock-snap.netlify.app/",
    source: "https://github.com/PrashantS360/StockSnap",
  },
  {
    img: MovieHive,
    title: "MovieHive",
    desc: "With just one search, retrieve in-depth information about any desired movie, encompassing all relevant details and insights.",
    demo: "https://movie-hive.netlify.app/",
    source: "https://github.com/PrashantS360/MovieHive",
  },
  {
    img: Dcode,
    title: "DCode",
    desc: "An app for competitive programmers to get all contests details at one place with awesome online IDE supported by python,c/cpp and more languages.",
    demo: "https://dcode-contests.netlify.app/",
    source: "https://github.com/PrashantS360/DCode",
  },
  {
    img: Weather,
    title: "Weather App",
    desc: "A real-time update weather app using open weather map api with location(longitude/latitute) shown in map which used mapbox.",
    demo: "https://hows-city-weather.netlify.app/",
    source: "https://github.com/PrashantS360/Weather-App",
  },
  {
    img: Tictactoe,
    title: "Tic-Tac-Toe",
    desc: "A memorable game from childhood with some extra features where you can select different emojis as player and control game sound.",
    demo: "https://prashants360.github.io/TicTacToe/",
    source: "https://github.com/PrashantS360/TicTacToe",
  }
]
